import React, { FC } from "react";

import PopUp from "../PopUp";
import Button from "../Button";
import OutlineButton from "../OutlineButton";

import { ConfirmPopUpModalProps } from "./models";
import { ButtonSection, ModalStyled } from "./styles";

const ConfirmPopUp: FC<ConfirmPopUpModalProps> = ({
  isLoading,
  opened,
  title,
  children,
  cancelButtonTitle,
  confirmButtonTitle,
  onCancel,
  onSubmit,
}) => {
  return (
    <PopUp opened={opened} title={title}>
      <ModalStyled>
        {children}
        <ButtonSection>
          <OutlineButton type="button" onClick={onCancel} disabled={isLoading}>
            {cancelButtonTitle || "Abandon"}
          </OutlineButton>
          <Button type="submit" onClick={onSubmit} disabled={isLoading}>
            {confirmButtonTitle || "Confirm"}
          </Button>
        </ButtonSection>
      </ModalStyled>
    </PopUp>
  );
};

export default ConfirmPopUp;
